module.exports = __webpack_public_path__ + "img/UMS_TrainerBackend_KURSE_Pic.7df06558.png";